import axios from "axios";
import FileType from "../assets/Enums/FileType";
import _ from 'lodash';
import verifyToken from '../queries/verify-token';
import { default as store } from '../plugins/vuex.mongo';
import { GraphQLClient } from 'graphql-request';
const client = new GraphQLClient(`${process.env.VUE_APP_BUS_API_URL}/graphql`)

export const MongoMixins = {
    methods: {
        verifyToken(jwt, token) {
          return client.request(verifyToken, { jwt, token })
        },
        requestPasswordReset(email, type) {
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/reset-password`, { email, type });
        },
        resetPassword(password, token, jwt) {
          return axios.put(`${process.env.VUE_APP_BUS_API_URL}/reset-password/${token}/${jwt}`, { password });
        },
        emailSignIn(email, password){
            return axios.post(`${process.env.VUE_APP_BUS_API_URL}/login-business`, { email, password });
        },
        signUserOut(){
            return axios.post(`${process.env.VUE_APP_BUS_API_URL}/logout-business`, 
              { withCredentials: true , headers: { Authorization: `JWT ${store.state.token}`} });
        },
        submitClientList(file) {
          const body = new FormData();
          body.append('file', file);
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/client-list-upload`, body,
            { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}`} });
        },
        submitCompanyInfo(companyObj) {
            return axios.post(`${process.env.VUE_APP_BUS_API_URL}/register-business`, companyObj);
        },
        async submitPhotos(partnerId, photoObjs) {
            let photoPromises = [];
            try {
              for (let i = 0; i < photoObjs.length; i++) {
                const item = photoObjs[i].photoFile;
    
                photoPromises.push(this.submitPhoto(partnerId, item, photoObjs[i].type))
              }
              await Promise.all(photoPromises);
          } catch (e) {
            console.log('company photo upload error: ' + e.message);
          }
        },
        submitPhoto(partnerId, file, fileType){
            const formData = new FormData();
            formData.set('file', file);
            formData.set('busId', partnerId);
            formData.set('type', fileType);

            if(fileType === FileType.EVENT){
              return axios.post(`${process.env.VUE_APP_BUS_API_URL}/register-event-image-upload`, formData,
                { headers: { 'content-type': 'multipart/form-data', Authorization: `JWT ${store.state.token}` }, withCredentials: true });
            } else if(fileType === FileType.ADVERTISEMENT || fileType == FileType.FAVICON){
              return axios.post(`${process.env.VUE_APP_BUS_API_URL}/business-image-upload`, formData,
                { headers: { 'content-type': 'multipart/form-data', Authorization: store.state.token ? `JWT ${store.state.token}` : undefined }, withCredentials: !!store.state.token });
            } else {
              return axios.post(`${process.env.VUE_APP_BUS_API_URL}/register-image-upload`, formData,
                { headers: { 'content-type': 'multipart/form-data', Authorization: store.state.token ? `JWT ${store.state.token}` : undefined }, withCredentials: !!store.state.token });
            }
        },
        async generateBusinessLocationData(address) {
            let searchString;
            if (!address.line1 || !address.city || !address.state) {
              throw Error('GEOCODE ERROR: Address object missing search parameters.');
            } else {
              searchString = encodeURIComponent(`${address.line1}, ${address.city}, ${address.state.abbreviation}`);
      
              console.log(address);

              return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?key=${process.env.VUE_APP_GOOGLE_API_KEY}&address=${searchString}`,
                { withCredentials: false });
            }
        },
        updateBusinessPage(page) {
          const files = page.newImages ? page.newImages.map(i => ({ id: `${i.index}`, file: i.photo.photoFile })) : [];
          console.log(files);
          const pageData = this.jsonToFormData(page);

          for(let i = 0; i < files.length; i++) {
            pageData.append('files', files[i].file);
          }

          return axios.put(`${process.env.VUE_APP_BUS_API_URL}/business-page`, pageData, 
            { withCredentials: true, headers: { 'content-type': 'multipart/form-data', Authorization: `JWT ${store.state.token}` } });
        },
        submitSettings(settings) {
          const formData = this.jsonToFormData(settings);
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/business-settings`, formData, 
            { withCredentials: true, headers: { 'content-type': 'multipart/form-data', Authorization: `JWT ${store.state.token}` } });
        },
        submitPartnerData(data) {
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/business-data`, data, 
            { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        submitDailyDeals(locationId, dailyDeals){
          
          dailyDeals.forEach(deal => {
            deal.open = false;
          });
          
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/post-deals`,
            { busId: locationId, deals: dailyDeals, dealType: "DAILY" }, { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        submitGroupDeals(locationId, groupDeals){
          // logic for submitting group deal photos needs to be added.
          groupDeals.forEach(deal => {
            deal.open = false;
          });
          
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/post-deals`,
            { busId: locationId, deals: groupDeals, dealType: "GROUP" }, { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        async submitAdvertisements(partnerId, ads){
          for(const ad of ads){
            console.log(ad);
            const photoRef = ad && ad.srcFile ? await this.submitPhoto(partnerId, ad.srcFile, FileType.ADVERTISEMENT) : null;
            
            ad.src = photoRef ? photoRef.data.link : ad.src;
            ad.imageId = photoRef ? photoRef.data.pid : undefined;
          }

          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/post-advertisements`, { partnerId, ads: ads.map(s => _.omit(s, 'localId')) },
            { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        submitEventRequest(eventInfo){
          const requestingPartner = this.$store.getters.partnerId;
          const requestingGeoHash = this.$store.getters.geoHashGroup;

          eventInfo.requestingPartner = requestingPartner
          eventInfo.placeIds = Array.from(new Set([requestingPartner,...eventInfo.selected]));
          eventInfo.geoHashGroup = requestingGeoHash;
      
          delete eventInfo.selected;
          console.log(`partner: ${requestingPartner} geoHash: ${requestingGeoHash}`);
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/register-event`, eventInfo,
            { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        async searchForLocation(searchString, locationTypes, geoHashGroup){
          return axios.get(`${process.env.VUE_APP_BUS_API_URL}/business-text-search` + 
            `?searchString=${ encodeURI(searchString) }&locationTypes=${ encodeURI(JSON.stringify(locationTypes)) }` +
            `&geoHash=${ encodeURI(geoHashGroup) }`);
        },
        getBusinessEvents(busId){
          return axios.get(`${process.env.VUE_APP_BUS_API_URL}/get-events?busId=${encodeURI(busId)}`, 
            { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        submitBusinessMenu(partnerId, menuPDF){
          const data = new FormData();
          data.set('busId', partnerId);
          data.set('type', FileType.MENU);
          data.set('file', menuPDF);

          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/business-image-upload`,
            data, { headers: { 'content-type': 'multipart/form-data', Authorization: `JWT ${store.state.token}` } });
        },
        deleteBusinessMenu(partnerId){
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/business-image-upload`, 
            { busId: partnerId, type: FileType.MENU }, { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        submitPayment(data){
          console.log('post ', store.state.token)
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/post-payment`, data,
            { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        touchApi(){
          return axios.get(`${process.env.VUE_APP_BUS_API_URL}/session`);
        },
        getBusinessPage(busId, pageType) {
          return axios.get(`${process.env.VUE_APP_BUS_API_URL}/business-pages/${busId}${pageType ? `/${pageType}` : ''}`);
        },
        createBusinessPage(pageType) {
          return axios.post(`${process.env.VUE_APP_BUS_API_URL}/business-page`, { pageType }, 
            { withCredentials: true, headers: { Authorization: `JWT ${store.state.token}` } });
        },
        buildFormData(formData, data, parentKey) {
          if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            Object.keys(data).forEach(key => {
              this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
            })
          } else {
            const value = data == null ? '' : data
        
            formData.append(parentKey, value)
          }
        },
        jsonToFormData(data) {
          const formData = new FormData()
        
          this.buildFormData(formData, data)
        
          return formData
        }
        // async deleteBusinessMenu(partnerId){
        //     await storage.ref(partnerId)
        //       .child('menu.pdf').delete()
        //     appStore.collection('partnerships/businesses/date-locations')
        //       .doc(partnerId).update({ menuLink: null }).then(() =>{
        //         this.$store.dispatch('UPDATE_MENU', null);
        //       })
        //   },
        //   async submitBusinessMenu(partnerId, menuPDF){
        //     const menuRef = storage.ref(partnerId)
        //       .child('menu.pdf')
        //     await menuRef.put(menuPDF)
        //     const menuURL = await menuRef.getDownloadURL();
        //     appStore.collection('partnerships/businesses/date-locations')
        //       .doc(partnerId).update({ menuLink: menuURL }).then(() =>{
        //         this.$store.dispatch('UPDATE_MENU', menuURL);
        //       })
        //   },
    }
}